<template>
  <div>
    <!-- 语言选择器 -->
    <div class="languageWrapper">
      <div class="languageContainer" @click.stop="toggleLangMenu">
        <span class="settingIco">🌍 {{ currentLangLabel }} </span>
      </div>

      <!-- 语言弹窗 -->
      <div v-if="showLangMenu" class="langPopup">
        <div class="langItem" @click="selectLang('en')">English</div>
        <div class="langItem" @click="selectLang('zh')">中文</div>
        <div class="langItem" @click="selectLang('vn')">VN</div>
      </div>
    </div>

    <!-- 背景图容器 - 使用两张图片拼接 -->
    <div class="container">
      <img :src="background1Image" class="bgImage" alt="" />
      <img :src="background2Image" class="bgImage" alt="" />
    </div>

    <!-- 浮动下载条 -->
    <div class="downloadBar">
      <div class="downloadLeft">
        <img src="../assets/logo.png" class="downloadLogo" />
        <div class="downloadText">
          <div class="appName">Yame</div>
          <div class="appDesc" v-if="isEnglish()">
            Level Up Your Social Skills
          </div>
          <div class="appDesc" v-else-if="isChinese()">突破社交能力</div>
          <div class="appDesc" v-else>Bứt kĩ xã hội</div>
        </div>
      </div>
      <div class="downloadBtn" v-if="isEnglish()" @click="downloadApp">
        Enter App
      </div>
      <div class="downloadBtn" v-else-if="isChinese()" @click="downloadApp">
        进入应用
      </div>
      <div class="downloadBtn" v-else @click="downloadApp">Vào ứng dụng</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "langpage",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      lan: "en",
      showLangMenu: false,
    };
  },

  computed: {
    currentLangLabel() {
      if (this.lan === "en") return "English";
      if (this.lan === "zh") return "中文";
      return "VN";
    },
    background1Image() {
      if (this.lan === "en") {
        return require("../assets/icon_bg1_en.png");
      } else if (this.lan === "zh") {
        return require("../assets/icon_bg1_zh.png");
      } else {
        return require("../assets/icon_bg1_vi.png");
      }
    },
    background2Image() {
      if (this.lan === "en") {
        return require("../assets/icon_bg2_en.png");
      } else if (this.lan === "zh") {
        return require("../assets/icon_bg2_zh.png");
      } else {
        return require("../assets/icon_bg2_vi.png");
      }
    },
  },

  methods: {
    toggleLangMenu() {
      this.showLangMenu = !this.showLangMenu;
    },

    selectLang(lang) {
      this.lan = lang;
      this.showLangMenu = false;
    },

    isEnglish() {
      return this.lan === "en";
    },

    isChinese() {
      return this.lan === "zh";
    },

    // 下载 app
    downloadApp() {
      const inviteCode = this.$route.query.shareId;
      if (window.openInstallInstance) {
        window.openInstallInstance.wakeupOrInstall({
          bindData: {
            shareId: inviteCode,
          },
          from: "h5_share",
        });
      }
    },
  },
};
</script>

<style scoped>
html {
  width: 100%;
  height: 100%;
}

.container {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 68px;
  display: flex;
  flex-direction: column;
}

.bgImage {
  width: 100%;
  height: auto;
  display: block;
}

.languageContainer {
  width: 100px;
  height: 28px;
  background: linear-gradient(180deg, #e56aee 0%, #f89ade 100%);
  border-radius: 16px 16px 16px 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 24px;
  cursor: pointer;
}

.settingIco {
  font-size: 16px;
  margin-left: 6px;
}

/* 底部浮动下载条 */
.downloadBar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 68px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 999;
  background: white;
}

/* 左侧 */
.downloadLeft {
  display: flex;
  align-items: center;
}

.downloadLogo {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  margin-right: 8px;
}

.downloadText {
  display: flex;
  flex-direction: column;
}

.appName {
  font-size: 16px;
  font-weight: 500;
  color: #323233;
}

.appDesc {
  font-size: 12px;
  color: #969799;
}

/* 右侧按钮 */
.downloadBtn {
  height: 32px;
  padding: 0 8px;
  border-radius: 8px;
  background: #6742f7;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.languageWrapper {
  position: fixed;
  right: 10px;
  top: 20px;
  z-index: 200;
}

/* 弹出框 */
.langPopup {
  position: absolute;
  top: 36px;
  right: 0;
  width: 100px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

/* 单个语言项 */
.langItem {
  padding: 8px 0;
  text-align: center;
  font-size: 14px;
  color: #323233;
  cursor: pointer;
}

.langItem:hover {
  background: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/langpage.vue